(function (angular) {
  "use strict";

  angular.module("app").directive("categoryTreeNodes", CategoryTreeNodes);

  function CategoryTreeNodes() {
    function categoryTreeNodesLink($scope) {
      $scope.nodeDepth = $scope.nodeDepth || 1;
      $scope.maxDepth = $scope.maxDepth || 10;
    }

    return {
      restrict: "E",
      templateUrl: "directives/category-tree-nodes.html",
      link: categoryTreeNodesLink,
      scope: {
        nodeDepth: "=?",
        maxDepth: "=?",
        categories: "=",
        categoryBeingEdited: "=",
        setCategoryBeingEdited: "=",
        cancelCategoryBeingEdited: "=",
        saveCategoryBeingEdited: "=",
        addNewCategory: "=",
        saveNewCategory: "=",
        deleteCategory: "=",
      },
    };
  }
})(angular);
